module.exports = __webpack_public_path__ + "static/media/spinner.8fdd3eb7.svg";